/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Draft_Discarded1Inputs */

const vi_cmspost_draft_discarded1 = /** @type {(inputs: Cmspost_Draft_Discarded1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã bỏ nháp, quay về bản đang chạy trên web.`)
};

/**

* @param {Cmspost_Draft_Discarded1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_draft_discarded1 = /** @type {((inputs?: Cmspost_Draft_Discarded1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Draft_Discarded1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_draft_discarded1(inputs)
});
export { cmspost_draft_discarded1 as "cmsPost_draft_discarded" }